import styled, { css } from 'styled-components';

export const Container = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-direction: column;
    gap: 16px;
    padding: 24px 24px 48px 24px;

    @media (max-width: ${theme.v2.breakpoints.sm}) {
      padding: 16px 16px 32px 16px;
    }
  `}
`;

export const WrapperLoaderPage = styled.div`
  ${({ theme }) => css`
    background-color: ${theme.v2.colors.neutral.highPure};
    z-index: 100;
    gap: 6px;
    width: 100%;
    height: 60vh;
    max-height: 700px;
    border-radius: 16px;    
  `}
`;
